import { detect } from 'detect-browser';

let _detected: ReturnType<typeof detect> | null = null;
const getDetected = () => (_detected ??= detect());

export const detectBrowser = () => getDetected()?.name ?? '';
export const detectOS = () => getDetected()?.os ?? '';

export const isIOS = () => {
  const os = detectOS();
  return os.toLowerCase().includes('ios');
};
export const isAndroid = () => {
  const os = detectOS();
  return os.toLowerCase().includes('android');
};
export const isMobile = () => {
  return isAndroid() || isIOS();
};
